import { isSharedClound } from "@/api";
import { MY_ACCOUNT } from "@/components/viewer/ui/constants/event.constants.share";
import store from "@/store";
import { windowActionFn } from "@/utils/utils";

function assertOffLine() {
    if (!window.__online__) {
        store.appStore.doNotifyErrors('offline');
        return true;
    }
    return false;
}
export function goMyAccount() {
    if (assertOffLine()) return;
    store.userStore.doGoToAccount();
    if (store.appStore.isCollaborationMode()) {
        store.userStore.doSendGAEvent({ eventKey: MY_ACCOUNT, label: 'review_mode_upper_right_area' } as any);
    } else {
        store.userStore.doSendGAEventByUser({ eventKey: MY_ACCOUNT, label: 'upper_right_area' } as any);
    }
}

export function navToWithBlank(href, butName) {
    if (assertOffLine()) return;
    if (store.appStore.isCollaborationMode()) {
        store.userStore.doSendGAEvent({ eventKey: butName, label: 'review_mode_upper_right_area' } as any);
    } else {
        store.userStore.doSendGAEventByUser({ eventKey: butName, label: 'upper_right_area' } as any);
    }
    windowActionFn(window, 'open', [href])
}

export function signOutFromAvatar(pathname: string) {
    if (window.pdfui) {
        window.pdfui.getComponentByName('fv--text-selection-tooltip').then(tooltip => tooltip && tooltip.hide());
    }
    if (store.teamsAppStore.inTeamsApp) {
        window.onShowToSaveBeforeOpen((isToSave) => {
            if (!isToSave) {
                store.userStore.loginOut(false);
            }
        })
    } else if (isSharedClound()) {
        store.userStore.loginOut(false, true);
    } else if (pathname === "/feedback") {
        store.userStore.loginOut(false);
    } else {
        window.onShowToSaveBeforeOpen((isToSave) => {
            if (!isToSave) {
                store.collaborationStore.exitCollaboration(true)
                store.userStore.loginOut(false);
            }
        })
    }
}
